import { TTRouteConfig } from "@tt-app/models";
import { ROUTES } from "@tt-app/constants";

const { SKILLS } = ROUTES;

export const skillsRoutes: TTRouteConfig[] = [
  {
    name: SKILLS.OVERVIEW.NAME,
    path: SKILLS.OVERVIEW.PATH,
    type: "page",
    accessLevel: "authenticated",
    component: () => import(/*webpackChunkName: "tt-core" */ "@tt-app/views/skills/Skills.vue")
  },
  {
    name: SKILLS.VOCABULARY_PRACTICE.NAME,
    path: SKILLS.VOCABULARY_PRACTICE.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/skills/VocabularyPractice.vue")
  },
  {
    name: SKILLS.PRONUNCIATION_PRACTICE.NAME,
    path: SKILLS.PRONUNCIATION_PRACTICE.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/skills/PronunciationPractice.vue")
  },
  {
    name: SKILLS.LISTENING_PRACTICE.NAME,
    path: SKILLS.LISTENING_PRACTICE.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/skills/ListeningPractice.vue")
  }
];
